import { useInstance, onUnmounted } from 'intact-vue';
export function useState(value, isEqual) {
  var instance = useInstance();
  var state = {
    value: value,
    set: function set(value) {
      var oldValue = state.value;
      if (isEqual) {
        if (isEqual(oldValue, value)) {
          // @ts-ignore
          state.value = value;
          return;
        }
      } else {
        if (oldValue === value) return;
      }
      // @ts-ignore
      state.value = value;
      instance.forceUpdate();
      callListeners(state, value, oldValue);
    },
    listeners: null
  };
  onUnmounted(function () {
    return state.listeners = null;
  });
  return state;
}
export function watchState(state, callback) {
  if (!state.listeners) state.listeners = [];
  state.listeners.push(callback);
}
function callListeners(state, newValue, oldValue) {
  var listeners = state.listeners;
  if (listeners) {
    for (var i = 0; i < listeners.length; i++) {
      listeners[i](newValue, oldValue);
    }
  }
}